module.exports = __webpack_public_path__ + "assets/img/icon-5.c1910988.png";